import { FunnelItem } from 'src/app/models/funnels';
import { Title } from '@angular/platform-browser';
import { SharedOwnerDashboardService } from 'src/app/shared/layout/owner-dashboard/shared-owner-dashboard.service';
import {
  trigger,
  transition,
  style,
  animate,
  state,
} from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FilteringTypeModel, SortingTypeModel } from 'src/app/models/portal';

import { SharedOfferService } from '../../../../offer/shared-offer.service';
import {
  PortalViewPageStatusEnum,
  SharedPortalViewService,
} from '../../shared-portal-view.service';
import { OfferItem } from 'src/app/components/user-dashboard/offer/models/offer';

@Component({
  selector: 'app-portal-subscribers',
  templateUrl: './portal-subscribers.component.html',
  styleUrls: ['./portal-subscribers.component.css'],
  animations: [
    trigger('inOutAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('0.5s ease-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('0.5s ease-in', style({ opacity: 0 })),
      ]),
    ]),
    trigger('shrinkOut', [
      state('in', style({})),
      transition('* => void', [
        style({ transform: 'translateX(0)', opacity: 1 }),
        animate(300, style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
      transition('void => true', [
        style({ transform: 'translateX(-150px)', opacity: 0 }),
        animate(400, style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
    ]),
    trigger('shrinkOutOnlyIn', [
      state('in', style({})),
      transition('void => *', [
        style({ transform: 'translateX(250px)', opacity: 0 }),
        animate(300, style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
    ]),
  ],
})
export class PortalSubscribersComponent implements OnInit {
  constructor(
    public sharedPortalViewService: SharedPortalViewService,
    public sharedOfferService: SharedOfferService,
    private route: Router,
    public sharedOwnerDashboardService: SharedOwnerDashboardService,
    private title: Title,
  ) {
    this.sharedPortalViewService.setPageStatus(
      PortalViewPageStatusEnum.marketing_subscribers,
    );
  }

  async ngOnInit() {
    // await this.sharedPortalViewService.getPortalSubscribers();
    // this.sharedOfferService.loaded = true;
    // this.title.setTitle(
    //   this.sharedPortalViewService.currentWebsite.website.label + ' > ' + 'Offers'
    // );
  }

  async onChangeFilterFunnel(funnel: FunnelItem) {
    // if (!!funnel.id && funnel.id != -1) {
    //   await this.sharedPortalViewService.getPortalSubscribers(funnel.id);
    // } else {
    //   await this.sharedPortalViewService.getPortalSubscribers();
    // }
  }

  // async reloadPortalOffers() {
  //   await this.sharedPortalViewService.reloadPortalOffers();
  // }

  // async setOfferAsDefault(offer: OfferItem) {
  //   const currentDefaultOffer =
  //     this.sharedPortalViewService.currentWebsite.website.offers.find(
  //       (a) => a.isDefault === true
  //     );
  //   if (!!currentDefaultOffer) {
  //     Swal.fire({
  //       allowOutsideClick: false,
  //       input: 'checkbox',
  //      customClass: {
  //       popup: 'swal-lg',
  //     },
  //       inputPlaceholder: `
  //       I confirm that I want to set this offer as default
  //         `,
  //       title:
  //         'Are you sure you want to set <strong> this offer as Default?</strong>',
  //       html: `
  //       I'm sure i want to set
  //               <strong>${offer.title}</strong> as the
  //               default offer for portal
  //               <strong>${this.sharedPortalViewService.currentWebsite.website.label}</strong>
  //               <span *ngIf="!!offerSettings?.parentPortal?.defaultOffer?.title"
  //                 >, and i know that it will override the current default offer
  //                 <strong>${currentDefaultOffer.title}</strong></span
  //               >
  //       `,
  //       confirmButtonText: 'Set As Default',
  //       showLoaderOnConfirm: true,
  //       heightAuto: false,
  //       preConfirm: async () => {
  //         for (const offer of this.sharedPortalViewService.currentWebsite.website
  //           .offers) {
  //           offer.isDefault = false;
  //         }
  //         await this.sharedOfferService.setOfferAsDefault(offer.id, offer);
  //         await this.reloadPortalOffers();
  //       },
  //       showCancelButton: true,
  //       reverseButtons: true,
  //       inputValidator: (result) => {
  //         return !result && 'You need to agree';
  //       },
  //     }).then((res) => {});
  //     const deleteCheck = Swal.getInput();
  //     const confirmCheck = Swal.getConfirmButton();
  //     const cancelButton = Swal.getCancelButton();

  //     confirmCheck.setAttribute('disabled', 'disabled');
  //     confirmCheck.setAttribute('style', 'pointer-events: none;');
  //     deleteCheck.addEventListener('change', function () {
  //       if (this.checked) {
  //         confirmCheck.removeAttribute('disabled');
  //         confirmCheck.removeAttribute('style');
  //       } else {
  //         confirmCheck.setAttribute('disabled', 'disabled');
  //         confirmCheck.setAttribute('style', 'pointer-events: none;');
  //       }
  //     });
  //     confirmCheck.addEventListener('click', function () {
  //       confirmCheck.innerHTML = 'Processing, Please Wait...';
  //       cancelButton.setAttribute('disabled', 'disabled');
  //       confirmCheck.setAttribute('disabled', 'disabled');
  //       deleteCheck.setAttribute('disabled', 'disabled');
  //     });
  //   } else {
  //     await this.sharedOfferService.setOfferAsDefault(offer.id, offer);
  //     await this.reloadPortalOffers();
  //   }
  // }

  // // Sort And Filtering Features

  // deleteOffer(offer: OfferItem) {
  //   // this.sharedPortalViewService.deleteOfferAlert(offer);
  // }

  cloneOffer(offer: OfferItem) {
    this.sharedOfferService.cloneOfferAlert(offer);
  }

  viewProduct(id: number) {
    this.route.navigate(['dashboard', 'product', id, 'view']);
  }

  async editOffer(id: number) {
    await this.route.navigate(['dashboard', 'offer', id, 'edit']);
  }

  // async publishOffer(offer: OfferItem) {
  //   this.sharedOfferService.changeOfferStatus(false, offer, 'status');
  // }

  // async draftOffer(offer: OfferItem) {
  //   // await this.editOffer(offer.id);
  //   this.sharedOfferService.changeOfferStatus(true, offer, 'status');
  // }

  goToTutorials() {
    this.route.navigate(['/dashboard/tutorials']);
  }

  consoleHandler(data: any) {}
}
